enum COLORS {
  BLACK = '#000000',
  WHITE = '#FFFFFF',
  CHECKED = '#1E3951',
  CHECKED_FILLED = '#A4BBCF',
  CHECKED_SECONDARY = '#94B0C8',
  ON_PRIMARY = '#082A49',
  ON_PRIMARY_CONTAINER = '#88BEEB',
  DROPDOWN_GREY = '#49454F',
  PRIMARY_CONTAINER = '#083B67',
  SECONDARY_CONTAINER = '#1E3951',
  VALID = '#88EBCD',
  ON_VALID = '#08674B',
  NEUTRAL_100 = '#F5F6F8',
  NEUTRAL_200 = '#E6EAED',
  NEUTRAL_300 = '#CED4DB',
  NEUTRAL_400 = '#B1B6BC',
  NEUTRAL_500 = '#94989E',
  NEUTRAL_600 = '#777A7F',
  NEUTRAL_700 = '#5A5C61',
  NEUTRAL_800 = '#3D3E42',
  NEUTRAL_900 = '#2A2B2F',
  NEUTRAL_925 = '#191A1E',
  NEUTRAL_950 = '#08080C',
  PRIMARY_050 = '#E6F1FB',
  PRIMARY_100 = '#CDE4F7',
  PRIMARY_300 = '#88BEEB',
  PRIMARY_400 = '#74B3E8',
  PRIMARY_500 = '#36A5F0',
  PRIMARY_600 = '#0778D6',
  PRIMARY_700 = '#1348C8',
  PRIMARY_750 = '#152C65',
  PRIMARY_800 = '#082A49',
  BUTTON_PRIMARY_HOVER = '#307EC1',
  BUTTON_SECONDARY_HOVER = '#3E4147',
  BUTTON_TERTIARY_HOVER = '#202229',
  NAV_ACTIVE = '#D9E3EB',
  NAV_HOVER = '#334E65',
  NAV_COMPLETED = '#88BEEB',
  NAV_COMPLETED_HOVER = '#3E4147',
  PILL = '#2F3238',
  TOOLTIP = '#5B5B5C',
  ERROR = '#F2B8B5',
}

export default COLORS;
